import axios from 'axios';
const constant = {};
constant.env = process.env;//该值指向config.(build argv).js


axios.defaults.withCredentials = true; //允许跨域携带cookie信息
axios.defaults.timeout = 120000; //2分钟
axios.defaults.headers['Cache-Control'] = 'no-cache'

export default constant;


// WEBPACK FOOTER //
// ./src/common/constant.js